module.exports = __webpack_public_path__ + "static/img/13areaB_6.34bfc96.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/13areaB_6.png
// module id = 1122
// module chunks = 1